/** 为正文 h2/h3 注入锚点 id，供 TOC 使用 */
export function injectHeadingIds(html) {
	if (!html) return { html: '', toc: [] }
	const toc = []
	let index = 0
	const withIds = html.replace(/<h([23])([^>]*)>([\s\S]*?)<\/h\1>/gi, (match, level, attrs, inner) => {
		if (/\bid=/.test(attrs)) return match
		const text = inner.replace(/<[^>]+>/g, '').trim()
		const id = `blog-section-${++index}`
		toc.push({ id, text, level: Number(level) })
		return `<h${level} id="${id}"${attrs}>${inner}</h${level}>`
	})
	return { html: withIds, toc }
}
